export default __webpack_public_path__ + "static/media/country.2faa012e.svg";